import { createSelector } from "reselect";

export const getContacts = (state) => state.humanContacts;
export const getSelectedHumanId = (state, human) => human.id;

export const getSelectedHumanEmail = createSelector(
  [getContacts, getSelectedHumanId],
  (contacts, humanId) => {
    for (let c of contacts) {
      if (c.humanId === humanId && c.type === "email") {
        return c;
      }
    }
    return {};
  }
);
